import _ from 'lodash';

export default (transcript) => {
  const transcripts = [];
  if (transcript && _.has(transcript, 'results') && _.size(transcript.results) > 0) {
    transcript.results.forEach((result) => {
      transcripts.push(_.first(_.orderBy(result.alternatives, ['confidence'], ['desc'])));
    });
  }
  return transcripts.map((t) => t.transcript).join('');
};
